import React, { useState, useEffect, Fragment } from 'react';
// import { Link } from 'react-router-dom';
import { Icon } from '../../../../Common/Icon';
import { makeRoute, gtmSend } from '../../../../../helpers';
import cx from '../../../../../styles';
import { getUrlImage } from '../../../../../helpers';

const FeedSwitcherMobile = ({ currentFilter, currentSubFilter, currentFilterId, onClickHandler, t, appReducer, match, filtersList = [], userReducer }) => {

    const [showDropdown, toggleShowDropdown] = useState(false) 

    // filter dropdown values
    const subFilterList = {
        'newsfeed': t('menu_relevant'),
        'latest': t('community_tab_latest'),
        'popular': t('community_tab_trending'),
        'poll': t('community_tab_poll')
    }

    // title of feed page
    const feedPageTitle = {
        'newsfeed': t('community_title'),
        'latest': t('community_title'),
        'popular': t('community_title'),
        'poll': t('community_polls')
    }

    useEffect(() => {
        if(showDropdown){
            document.body.classList.add('ReactModal__Body--open');
        }
        else{
            document.body.classList.remove('ReactModal__Body--open');   
        }
    }, [showDropdown]);

    /*useEffect(() => {
        if(typeof window !== 'undefined' && document.getElementById('filter-wrap') && document.getElementById('active-filter')){
            document.getElementById('filter-wrap').scrollLeft = 0;
            document.getElementById('filter-wrap').scroll({
                left: document.getElementById('active-filter').getBoundingClientRect().left,
                behavior: 'smooth'
            })
        }
    })*/

    const clickHandler = (filter, subfilter, url, title, filterId) => {
        gtmSend('dynamic event', `${filter}-${filterId} filter`, 'click', title);
        onClickHandler(filter, subfilter, url, filterId);
        if([t('menu_relevant'), t('community_tab_latest'), t('community_tab_trending')].indexOf(title) !== -1 && currentFilter === filter && currentFilterId === filterId){
            toggleShowDropdown(!showDropdown);
        }
    }

    return (
        <div className={cx("normal-card", "no-pad", "bg-transp", "feeds-wrap", "feed-switcher-mobile")} style={{ background: 'none', border: 'none' }}>
            <div className={cx("flex", "flex-full-width", "flex-center")}>
                <div className={cx("left")}>
                    {
                        filtersList && filtersList.length > 1 && userReducer.id && ['poll','hash'].indexOf(currentFilter) === -1
                        ?
                            filtersList.map((filter) => {
                                if(filter.feed_type === currentFilter && filter.feed_type_id == currentFilterId){
                                    return  (
                                        <span key={filter.feed_type_id} className={cx("feed-title", currentFilter)}>
                                            {filter.sub_title}
                                        </span>
                                    )
                                }
                                return false;
                            })
                        :
                            <span className={cx("feed-title", currentFilter)}>
                                {
                                    currentFilter == 'hash'
                                    ?
                                        `#${match.params.slug}`
                                    :
                                        feedPageTitle[currentSubFilter]
                                }
                            </span>
                    }
                </div>
                <div className={cx("right")}>
                    <div className={cx("dropdown")}>
                        <button className={cx("dropbtn", "selected-filter")}>
                            {
                                ['poll','hash'].indexOf(currentFilter) === -1
                                ?
                                    <a href={makeRoute("/feed/poll",appReducer)} onClick={(e) => {e.preventDefault(); clickHandler('poll', 'poll', '/feed/poll', 'Poll', 0); gtmSend('cw_filter_apply', 'Filter', 'Filter by Poll', '--', 0)}}>{t('community_tab_poll')}</a>
                                :
                                    <a href={makeRoute("/feed?type=home_feed&id=0",appReducer)} onClick={(e) => {e.preventDefault(); clickHandler('home_feed', 'newsfeed', '/feed', 'Feed', 0); gtmSend('cw_filter_remove', 'Filter', 'Filter Remove', '--', 0)}}>{t('menu_feed')}</a>
                            }
                        </button>
                        {
                            ['poll','hash'].indexOf(currentFilter) === -1 &&
                            <Fragment>
                                <button className={cx("dropbtn")} onClick={() => toggleShowDropdown(!showDropdown)}>
                                    {subFilterList[currentSubFilter]}
                                    <Icon name="dropdown-icon" className="feed-filter-arrow" />
                                </button>
                                <div className={cx("dropdown-content", showDropdown ? 'show' : '')}>
                                    <div>{t('topic_filter_by')}</div>
                                    <a 
                                        href={makeRoute(`/feed?type=${currentFilter}&id=${currentFilterId}`, appReducer)} 
                                        onClick={(e) => { e.preventDefault(); clickHandler(['poll','hash'].indexOf(currentFilter) > -1 ? '' : currentFilter, 'newsfeed', `/feed`, subFilterList['newsfeed'], currentFilterId); gtmSend('cw_feed_sort', 'Sort', 'Feed', 'Sort by Relevant', 0)}}
                                    >
                                        {t('menu_relevant')}
                                    </a>
                                    <a 
                                        href={makeRoute(`/feed/latest?type=${currentFilter}&id=${currentFilterId}`,appReducer)} 
                                        onClick={(e) => { e.preventDefault(); clickHandler(['poll','hash'].indexOf(currentFilter) > -1 ? '' : currentFilter, 'latest', `/feed/latest`, subFilterList['latest'], currentFilterId); gtmSend('cw_feed_sort', 'Sort', 'Feed', 'Sort by Latest', 0)}}
                                    >
                                        {t('community_tab_latest')}
                                    </a>
                                    <a 
                                        href={makeRoute(`/feed/popular?type=${currentFilter}&id=${currentFilterId}`,appReducer)} 
                                        onClick={(e) => { e.preventDefault(); clickHandler(['poll','hash'].indexOf(currentFilter) > -1 ? '' : currentFilter, 'popular', `/feed/popular`, subFilterList['popular'], currentFilterId); gtmSend('cw_feed_sort', 'Sort', 'Feed', 'Sort by Trending', 0) }}
                                    >
                                        {t('community_tab_trending')}
                                    </a>
                                </div>
                                <div className={cx("dropdown-content-wrapper", showDropdown ? 'show' : '')} id="dropdown-content-wrapper" onClick={(e) => {if(e.target == document.getElementById('dropdown-content-wrapper')) toggleShowDropdown(false)}}>
                                </div>
                            </Fragment>
                        }
                    </div>
                </div>
            </div>
            {
                /* birth club list */
                userReducer.id && ['poll','hash'].indexOf(currentFilter) === -1 &&
                <div className={cx("flex", "flex-full-width", "flex-center", "filter-wrap")} id={"filter-wrap"}>
                    {
                        filtersList && filtersList.length > 1 &&
                        filtersList.map((filter) => {
                            return (
                                <a 
                                    key={filter.feed_type_id} 
                                    href={makeRoute(`/feed?type=${filter.feed_type}&id=${filter.feed_type_id}`, appReducer)}
                                    id={currentFilterId ? (currentFilterId == filter.feed_type_id && currentFilter === filter.feed_type ? 'active-filter' : '') : (filter.default ? 'active-filter' : '')}
                                    className={cx('each-filter',filter.feed_type_id? filter.feed_type_id : '0' , currentFilterId ? (currentFilterId == filter.feed_type_id && currentFilter === filter.feed_type ? 'active' : '') : (filter.default ? 'active' : ''))}
                                    onClick={(e) => { e.preventDefault(); clickHandler(filter.feed_type, 'newsfeed', `/feed`, filter.feed_type, filter.feed_type_id)}}
                                >
                                    <img src={filter.image || getUrlImage({imgPath: "prod-beyeu-assets/favicon/android-chrome-512x512.png", defaultImgPath: 'parenttown-prod/assets/tap_c_logo_512x512.png'})} alt={filter.title} width="40px" height="40px" />
                                    <span>{filter.title}</span>
                                </a>)
                        })
                    }
                </div>
            }
        </div>
    );
}

export default FeedSwitcherMobile;